export default __webpack_public_path__ + "static/media/groceries.65a0d77e.gif";